export const routes = [
  {
    path: "/groups",
    component: () => import(/* webpackChunkName: "tema" */ "./components/List"),
    name: "groups.list",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/groups/edit/:id",
    component: () =>
      import(/* webpackChunkName: "tema" */ "./components/AddEditGroup"),
    name: "groups.addEditGroup",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/groups/add",
    component: () =>
      import(/* webpackChunkName: "tema" */ "./components/AddEditGroup"),
    name: "groups.addGroup",
    meta: {
      requiresAuth: true,
    },
  },
];
